import styled from "styled-components";

import backgroundWeb from "../../../assets/Login/background-web.svg";

const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${backgroundWeb}) no-repeat center;
  background-size: cover;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px;
  border-radius: 8px;
  background-color: white;
  width: 360px;
  max-width: 92vw;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.primary};
    margin: 0;
  }
`;

export { Container, Card };
